export default function reducer(state = {
  sucursalesCR: undefined,
  lastFetched: undefined
}, action) {
  switch (action.type) {
    case "LOAD_SUCURSALES_CR": {
      state = { ...state, ...action.payload }
      break
    }
    default: {

    }
  }
  return state
}